import React, { ReactNode } from 'react'
import { Link } from 'react-router'
import cx from 'classnames'
import './style.sass'
import Icon from '../Icon'
import { IconNamesEnum } from '../Icon'

interface ArrowLinkProps {
	className?: string
	small?: boolean
	to?: string
	href?: string
	iconName?: IconNamesEnum
	children: ReactNode
}

export const ArrowLink = ({ small, className, to, href, iconName = 'arrow-right', children }: ArrowLinkProps) => {
	let Tag: any = 'a'
	let linkTo = {}

	if (to) {
		Tag = Link
		linkTo = { to }
	} else if (href) {
		linkTo = { href }
	}

	const cs = cx('ArrowLink', className, { 'ArrowLink--small': small })

	return (
		<Tag className={cs} {...linkTo}>
			<span className='ArrowLink__content'>{children}</span>
			<Icon className='ArrowLink__arrow' name={iconName} width={16} height={16} />
		</Tag>
	)
}

export default ArrowLink
